import React from 'react';
import { BaseBlockModel, BlockType, WysiwygBlock } from '../models/ecd-block-models';
import WysiwygBlockView from './block-type/wysiwyg-block';

interface Props {
	blockData: BaseBlockModel,
}

export function BlockFactory(props: Props){

	switch (props.blockData?.blockType) {
		case BlockType.WYSIWYGBlock: {
			return <WysiwygBlockView blockData={props.blockData as WysiwygBlock} />;
		}

		default: {
			return <>Unknown block type &apos;{props.blockData?.blockType}&apos;</>;
		}
	}
}
